import {SignIn, SignInModel, SignInParams} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteSignIn implements SignIn {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<SignInModel>,
	) {}

	async auth(body: SignInParams): Promise<SignInModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
